
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop } from "vue-property-decorator";
    import { BriefingProgress } from "@/model/BriefingProgress";

    @Component({})
    export default class BriefingProgressBar extends Vue {

        @Prop({ required: true })
        progress!: BriefingProgress;

        get mercuryWidthStyle(): Record<string, string> {
            return { width: `${this.progress.percent}%` };
        }

        get percentText(): string {
            return `${Math.round(this.progress.percent)}%`;
        }
        
        get briefingOverlayWidthStyle(): Record<string, string> {
            const percent = ((this.progress.quizStartsAtIndex + 1) / this.progress.totalPageCount) * 100.0;
            return { flex: `${percent}%` };
        }

        get quizOverlayWidthStyle(): Record<string, string> {
            const percent = ((this.progress.totalPageCount - this.progress.quizStartsAtIndex + 1) / this.progress.totalPageCount) * 100.0;
            return { flex: `${percent}%` };
        }
    }
